var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnsettledDoubtIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 70,
    viewBox: "0 0 69 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 68.0045C53.0015 68.0045 68 53.005 68 34.5022C68 15.9995 53.0015 1 34.5 1C15.9985 1 1 15.9995 1 34.5022C1 53.005 15.9985 68.0045 34.5 68.0045Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1365 21.9163C24.3658 23.3162 21.4465 24.9315 17.4504 25.0272C16.4693 26.7502 15.8711 28.8919 15.8711 31.2371C15.8711 36.8367 19.1733 41.3835 23.2292 41.3835C27.2851 41.3835 30.5991 36.8367 30.5991 31.2371C30.5991 27.0493 28.7567 23.4598 26.1365 21.9043V21.9163Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1151 21.9163C42.8858 23.3162 45.805 24.9315 49.8011 25.0272C50.7822 26.7502 51.3804 28.8919 51.3804 31.2371C51.3804 36.8367 48.0783 41.3835 44.0224 41.3835C39.9545 41.3835 36.6523 36.8367 36.6523 31.2371C36.6523 27.0493 38.4949 23.4598 41.1151 21.9043V21.9163Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1881 60.2033C27.9079 57.2719 30.4802 53.3114 34.9429 51.3491C39.4055 49.3988 44.0597 50.1885 45.3518 53.12",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1881 60.2033C27.9079 57.2719 30.4802 53.3114 34.9429 51.3491C39.4055 49.3988 44.0597 50.1885 45.3518 53.12",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4623 38.9765C26.4975 38.9765 28.1473 36.7051 28.1473 33.9033C28.1473 31.1014 26.4975 28.8301 24.4623 28.8301C22.4271 28.8301 20.7773 31.1014 20.7773 33.9033C20.7773 36.7051 22.4271 38.9765 24.4623 38.9765Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.418 23.8896C18.6224 14.7483 28.158 16.5431 28.158 16.5431C28.158 16.5431 20.2017 19.0318 13.418 23.8896Z",
    fill: "#231F20",
    stroke: "#231F20",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7904 38.9765C44.8256 38.9765 46.4754 36.7051 46.4754 33.9033C46.4754 31.1014 44.8256 28.8301 42.7904 28.8301C40.7552 28.8301 39.1055 31.1014 39.1055 33.9033C39.1055 36.7051 40.7552 38.9765 42.7904 38.9765Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1287 23.8896C47.9242 14.7483 38.3887 16.5431 38.3887 16.5431C38.3887 16.5431 46.3449 19.0318 53.1287 23.8896Z",
    fill: "#231F20",
    stroke: "#231F20",
    strokeWidth: 0.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7779 45.5235C61.8394 45.5235 65.9426 44.2914 65.9426 42.7715C65.9426 41.2516 61.8394 40.0195 56.7779 40.0195C51.7164 40.0195 47.6133 41.2516 47.6133 42.7715C47.6133 44.2914 51.7164 45.5235 56.7779 45.5235Z",
    fill: "#F12C7A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6255 45.5235C16.687 45.5235 20.7902 44.2914 20.7902 42.7715C20.7902 41.2516 16.687 40.0195 11.6255 40.0195C6.56406 40.0195 2.46094 41.2516 2.46094 42.7715C2.46094 44.2914 6.56406 45.5235 11.6255 45.5235Z",
    fill: "#F12C7A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsettledDoubtIcon);
export default __webpack_public_path__ + "static/media/unsettled-doubt-icon.43e8d5550a7e7c348f2ad4ef69cac672.svg";
export { ForwardRef as ReactComponent };